indexSearch = (function() {
  var _this = {
    init: function() {
   
      //select dropdowns
      _this.$formUIselects = $('.js-glbl-search-wbsk-formui-select')
      _this.$formUIselects.formUI({
        hasOptions: true
      })
      //date dropdowns
      _this.$formUIdates = $('.js-glbl-search-wbsk-formui-date')
      _this.$formUIdates.formUI({
        hasOptions: false
      })
      // add the date pickers
      var params,
          $lightpicker = _this.$formUIdates.find('.js-glbl-search-lightpick'),
          $datesTexts = _this.$formUIdates.find('.js-glbl-search-dateText'),
          $datesInputs = _this.$formUIdates.find('.js-glbl-search-dateInput')
      var picker =  new Lightpick({
        locale:datePickerLocale.nights,
        minDate: moment().startOf('day').add(1, 'day'),
        maxDate: moment().startOf('day').add(2, 'year'),
        inline: true,
        field: $lightpicker[0],
        secondField: $lightpicker[1],
        singleDate: false,
        selectForward: true,
        tooltipNights: true,
        onSelectEnd: function(start, end) {
          var start = picker.getStartDate(),
              end = picker.getEndDate(),
              length = end.diff(start, 'days')
          if (end && length) {
            $($datesTexts[0]).text(start.format('Do MMM YY'))
            $($datesTexts[1]).text(end.format('Do MMM YY'))
            $($datesInputs[0]).val(start.format('DDMMYYYY'))
            $($datesInputs[1]).val(end.format('DDMMYYYY'))
            _this.$formUIdates.data('formUI').closeAll()
          }
        }
      })
      picker.setDateRange(moment(), moment().add(7, 'd'))
    },
  }
  return _this
})()
